import React from 'react'

import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import useGoToOffers from '@sputnik/hooks/useGoToOffers'
import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'

interface OfferReadyBannerProps {
  salesforceCreditId: string
  authorizedSignerEmail: string
}

/* This status shows if status is not_started or if in_progress without savedSections
  - other considerations for showing this banner: 
  showGoToOfferButton = isLoggedInUserAuthorizedSigner && decisions?.length > 0 && !hasSelectedDecision 
*/
const OfferReadyBanner = ({ salesforceCreditId, authorizedSignerEmail }: OfferReadyBannerProps) => {
  const { decisions, handleGoToOffers, isLoadingGoToOffers } = useGoToOffers({
    salesforceCreditId,
    authSignerEmail: authorizedSignerEmail,
  })

  return (
    <div className='fs-unmask'>
      <StatusBanner
        bannerType={BannerType.Informative}
        subtext={
          <FormattedMessage
            defaultMessage='Take advantage of your credit line. <link>Review and accept {offers, plural, one {offer} other {offers}}</link>'
            id='sputnik.OfferReadyBanner__dezVS5'
            values={{
              offers: decisions?.length,
              link: (chunks) => (
                <TextLink
                  disabled={isLoadingGoToOffers}
                  size={TextLinkSizes.SMALL}
                  onClick={handleGoToOffers}
                >
                  {chunks}
                </TextLink>
              ),
            }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Your {offers, plural, one {offer is} other {offers are}} ready!'
            id='sputnik.OfferReadyBanner__1JRfgv'
            values={{ offers: decisions?.length }}
          />
        }
      />
    </div>
  )
}

export default OfferReadyBanner
